import React from "react";
import { Helmet } from "react-helmet";

function MetaScripts() {
  return (
    <>
      <Helmet
        script={[
          {
            type: "text/javascript",
            src: "https://cdn.tailwindcss.com?plugins=forms,typography,aspect-ratio,line-clamp",
          },
        ]}
      ></Helmet>
    </>
  );
}

export default MetaScripts;
